import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowmoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowmore_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M883.499 670.165a42.667 42.667 0 0 0 0-60.33L670.165 396.5a42.667 42.667 0 1 0-60.33 60.331l140.501 140.501h-451.67A85.333 85.333 0 0 1 213.334 512V170.667a42.667 42.667 0 0 0-85.333 0V512a170.667 170.667 0 0 0 170.667 170.667h451.669L609.835 823.168a42.667 42.667 0 0 0 60.33 60.33L883.5 670.166z"
    />
  </svg>
);
export default SvgArrowmoreIcon;
